import * as React from "react";
import "./Button.scss";

interface IButtonProps {
  // Event|undefined if preventDefault needed (ie Forms)
  action?: (evt: React.MouseEvent<HTMLButtonElement>) => void;
  type?: ButtonType;
  styles?: ButtonStyles[];
  btnIdentifier?: string | number;
}

// TODO Vllt nochmal 'ButtonStates' einführen, und ButtonType dann für FB, AMAZON, GPAY & PAYPAL benutzen
export enum ButtonType {
  default = "Button--primary",
  disabled = "Button--disabled",
}

export enum ButtonStyles {
  wide = "Button--wide",
  big = "Button--big",
  logo = "Button--logo",
  fb = "Facebook",
  datepicker = "Datepicker",
}

export const Button: React.FC<IButtonProps> = (props) => {
  const type = props.type || ButtonType.default;
  const styles = props.styles || [];
  const className = type + " " + styles.join(" ");

  const disabled = type === ButtonType.disabled;

  return (
    <button className={className} onClick={props.action} disabled={disabled} data-btn-identifier={props.btnIdentifier}>
      {props.children}
    </button>
  );
};
